var React = require('react');

function Bell (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.269 9.75A6.74 6.74 0 0 1 12.051 3c3.712.028 6.68 3.113 6.68 6.835v.665c0 3.358.703 5.306 1.322 6.371A.75.75 0 0 1 19.408 18H4.592a.75.75 0 0 1-.645-1.13c.62-1.064 1.322-3.013 1.322-6.37v-.75ZM9 18v.75a3 3 0 0 0 6 0V18","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Bell.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = Bell;

Bell.default = Bell;
